export default __webpack_public_path__ + "static/media/servicies-contract.icon.4599c702.svg";